import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  // 微信内部进件跳转的下载页面
  {
    path: "/download",
    name: "Download",
    component: () => import("../views/download"),
    meta: {
      title: "领取额度",
    },
  },
  // 协议页面
  {
    path: "/protocol",
    name: "Protocol",
    component: () => import("../views/protocol"),
    meta: {
      title: "协议",
    },
  },
  // 404页面
  {
    path: "/404",
    name: "NoPage",
    component: () => import("../views/404"),
    meta: {
      title: "404",
    },
  },
  // 产品推荐结果页面
  {
    path: "/productRecomed",
    name: "ProductRecomed",
    component: () => import("../views/productRecomed"),
    meta: {
      title: "产品推荐",
    },
  },
  // 了解分享借介绍页面
  {
    path: "/know",
    name: "Know",
    component: () => import("../views/know"),
    meta: {
      title: "了解分享借",
    },
  },
  // 关于分享借
  {
    path: "/aboutUs",
    name: "AboutUs",
    component: () => import("../views/app/aboutUs"),
    meta: {
      title: "关于分享借",
    },
  },
  // 理性消费小课堂
  {
    path: "/classroom",
    name: "Classroom",
    component: () => import("../views/app/classroom"),
    meta: {
      title: "理性消费小课堂",
    },
  },  
  // 进件页面(蓝色) 复制registerEntry_tl4页面 0511
  {
    path: "/registerEntry_tl9",
    name: "RegisterEntryTl9",
    component: () => import("../views/registerEntry_tl9"),
    meta: {
      title: "快速到账 借贷无忧",
    },
  }, 
     // 蓝色头部背景进件页面
  {
    path: "/registerEntry_tl10",
    name: "RegisterEntryTl10",
    component: () => import("../views/registerEntry_tl10"),
    meta: {
      title: "额度确认",
    },
  },
    // 黄色头部背景进件页面
  {
    path: "/registerEntry_tl11",
    name: "RegisterEntryTl11",
    component: () => import("../views/registerEntry_tl11"),
    meta: {
      title: "额度确认",
    },
  },
  {
    path: "/registerEntry_tl12",
    name: "RegisterEntryTl12",
    component: () => import("../views/registerEntry_tl12"),
    meta: {
      title: "额度确认",
    },
  },
  {
    path: "/matchSuccess",
    name: "MatchSuccess",
    component: () => import("../views/matchSuccess"),
    meta: {
      title: "匹配成功",
    },
  },
  // 三方签约结果
  {
    path: "/triContract",
    name: "TriContract",
    component: () => import("../views/triContract"),
    meta: {
      title: "三方签约结果",
    },
  },
  // 此路由为不同项目域名的演示流程进件页面（不调接口）
  {
    path: "/interProRegisterEntry",
    name: "InterProRegisterEntry",
    component: () => import("../views/interProRegisterEntry"),
    meta: {
      title: "三分钟最高可借20万",
    },
  },
  // 此路由为不同项目域名的演示流程完成（不调接口）
  {
    path: "/interProPassedSuccess",
    name: "InterProPassedSuccess",
    component: () => import("../views/interProPassedSuccess"),
    meta: {
      title: "三分钟最高可借20万",
    },
  },
  // 此路由为贷超产品跳转中间页面路由
  {
    path: "/convenientEntrance",
    name: "ConvenientEntrance",
    component: () => import("../views/convenientEntrance"),
    meta: {
      title: "产品推荐",
    },
  },
  // 活动
  {
    path: "/activity",
    name: "Activity",
    meta: {
      title: "",
    },
    component: () => import("../views/activity"),
    children: [
      // 转盘活动页面
      {
        path: "turntable",
        name: "Turntable",
        component: () => import("../views/activity/turntable"),
        meta: {
          title: "幸运大转盘",
        },
      },
      {
        path: "turntable/rule",
        name: "TurntableRule",
        component: () => import("../views/activity/turntable/rule"),
        meta: {
          title: "活动规则",
        },
      },
      {
        path: "turntable/prize",
        name: "TurntablePrize",
        component: () => import("../views/activity/turntable/prize"),
        meta: {
          title: "我的奖品",
        },
      },
    ],
  },
  // H5唤醒APP,
  {
    path: "/openApp",
    name: "OpenApp",
    component: () => import("../views/liftingAPP/openApp"),
    meta: {
      title: "打开分享借",
    },
  },
  // H5下载页，点击按钮跳应用市场,
  {
    path: "/downloadApp",
    name: "DownloadApp",
    component: () => import("../views/liftingAPP/downloadApp"),
    meta: {
      title: "下载分享借",
    },
  },
  {
    path: "/trialSuccess_tl7",
    name: "TrialSuccessTl7",
    component: () => import("../views/trialSuccess_tl7"),
    meta: {
      title: "贷款申请已提交",
    },
  },
  // 进件结果,进件成功
  {
    path: "/trialSuccess_tl8",
    name: "TrialSuccessTl8",
    component: () => import("../views/trialSuccess_tl8"),
    meta: {
      title: "贷款申请已提交",
    },
  },
  // 进件结果,进件失败
  {
    path: "/trialSuccess_tl9",
    name: "TrialSuccessTl9",
    component: () => import("../views/trialSuccess_tl9.vue"),
    meta: {
      title: "贷款申请已提交",
    },
  },
  // 非贷超兜底：进件推送失败且 isRedirectProductsPage !== 1
  {
    path: "/applyResult",
    name: "ApplyResult",
    component: () => import("../views/applyResult.vue"),
    meta: {
      title: "贷款申请已提交",
    },
  },
  // 进件成功推荐产品页（对齐小程序 pages/product，tl12）
  {
    path: "/trialSuccess_tl12",
    name: "TrialSuccessTl12",
    component: () => import("../views/trialSuccess_tl12.vue"),
    meta: {
      title: "贷款申请已提交",
    },
  },

  // H5还款计划
  {
    path: "/repaymentPlan",
    name: "RepaymentPlan",
    component: () => import("../views/repaymentPlan"),
    meta: {
      title: "还款计划",
    },
  },
  // 会员权益页面
  {
    path: "/member",
    name: "Member",
    component: () => import("../views/member"),
    meta: {
      title: "会员",
    },
  },
  //激活额度跳转页面
  {
    path: "/activeLimitDefauleJump",
    name: "activeLimitDefauleJump",
    component: () => import("../views/activeLimitDefauleJump"),
    meta: {
      title: "审批放款",
    },
  },

  // 匹配等待页面
  {
    path: "/matchWaiting",
    name: "MatchWaiting",
    component: () => import("../views/match/matchWaiting"),
    meta: {
      title: "资金匹配中",
    },
  },
  // 匹配成功结果详情页
  {
    path: "/matchResDetail",
    name: "MatchResDetail",
    component: () => import("../views/match/matchResDetail"),
    meta: {
      title: "确认申请",
    },
  },
  // 匹配成功结果详情页
  {
    path: "/applyWaiting",
    name: "ApplyWaiting",
    component: () => import("../views/match/applyWaiting"),
    meta: {
      title: "合同签署中",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});
router.beforeEach((to, from, next) => {
  var timestamp = new Date().getTime();
  to.query.tsp = timestamp;
  next();
});
export default router;
